// The downloads the tour advertises. WMV copies of old scenes only repeat an
// MP4 at the same height, so they're left out.
export const tourDownloadOptions = (options = []) =>
  options.filter((option) => option.format?.toLowerCase() !== "wmv")
